import { render, staticRenderFns } from "./ResetPasswordComplete.vue?vue&type=template&id=e2caeb96&scoped=true&"
import script from "./ResetPasswordComplete.vue?vue&type=script&lang=ts&"
export * from "./ResetPasswordComplete.vue?vue&type=script&lang=ts&"
import style0 from "./ResetPasswordComplete.vue?vue&type=style&index=0&id=e2caeb96&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2caeb96",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
